import { createRepository } from '@/shared/repositories/Repository'
import { BASE_URL, GET_SUBSCRIPTION_PATH, GET_CONNECT_PATH } from '@/shared/api'
import type { SubscriptionApiResponse, GetConnectResponse } from '../model/types'

const subscriptionRepository = createRepository({
  basePath: BASE_URL,
  useAuth: true
})

export const getSubscription = (all: boolean = false) => {
  return subscriptionRepository.get<SubscriptionApiResponse, { all: boolean }>(
    GET_SUBSCRIPTION_PATH,
    { all },
    {
      401: 'Необходима авторизация',
      404: 'Подписка не найдена',
      204: 'Подписка отсутствует',
    }
  )
}

export const getConnect = (subscriptionId: string) => {
  return subscriptionRepository.get<GetConnectResponse, { subscription_id: string }>(
    GET_CONNECT_PATH,
    { subscription_id: subscriptionId },
    {
      401: 'Необходима авторизация',
      404: 'Подписка не найдена',
      403: 'Подписка не принадлежит пользователю',
      400: 'Инструкции доступны только для X-Ray подписок',
    }
  )
} 